import React from "react";
import {
  TableBody,
  TableRow,
  TableCell,
  Avatar,
  IconButton,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

const TeamsTableBody = ({ teams, onMenuOpen }) => {
  return (
    <TableBody
      sx={{
        "& td, & th": {
          color: "#6A707E",
          fontWeight: 500,
          fontSize: "16px",
        },
      }}
    >
      {teams.map((team) => (
        <TableRow
          key={team.id}
          sx={{
            backgroundColor: "white",
            borderRadius: 2,
            boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.05)",
            "&:last-child td, &:last-child th": { borderBottom: 0 },
          }}
        >
          <TableCell>
            <Avatar alt={team.name} src={team.logo} sx={{ borderRadius: 0 }} />
          </TableCell>
          <TableCell>{team.teamName}</TableCell>
          <TableCell>{team.nickname}</TableCell>
          <TableCell>{team.triCode}</TableCell>
          <TableCell>{team.sport}</TableCell>
          <TableCell>{team.league}</TableCell>
          <TableCell>{team.country}</TableCell>
          <TableCell>{team.players}</TableCell>
          <TableCell align="right">
            <IconButton onClick={(e) => onMenuOpen(e, team.id)}>
              <MoreVertIcon />
            </IconButton>
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  );
};

export default TeamsTableBody;
